import './bootstrap';
import './pagination';

import LazyLoad from "vanilla-lazyload";
import {addBackToTop} from "vanilla-back-to-top";

/**
 * Base site class
 */
let Site = function () {

    let lazyLoadInstance;

    /**
     * Init back to top component
     */
    let initBackToTop = function () {
        addBackToTop({
            // diameter: 56,
            backgroundColor: '#ba995f',
            textColor: 'white',
        });
    };

    /**
     * Init image lazy load component
     */
    var initLazyLoad = function () {

        if (typeof lazyLoadInstance !== 'undefined') {
            return lazyLoadInstance.update();
        }

        lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy",
            load_delay: 100
        });
    };

    let initCarousel = function () {

        $('.gallery').owlCarousel({
            loop:false,
            margin:10,
            nav:true,
            dots: false,
            navText: ['<img src="/images/left-arrow.svg" />', '<img src="/images/right-arrow.svg" />'],
            // responsive:{
            //     0:{
            //         items:3
            //     },
            //     600:{
            //         items:3
            //     },
            //     1000:{
            //         items:3
            //     }
            // }
        });
    };

    let initFancyBox = function () {
        $('[data-fancybox="gallery"]').fancybox({
            // Options will go here
        });
    };

    let initShrinkMenu = function () {

        let header = document.getElementsByTagName('header')[0];

        let height = 128;

        let isShrink = false;

        window.addEventListener('scroll', () => {
            isShrink = document.body.scrollTop > height || document.documentElement.scrollTop > height;
            isShrink ? header.classList.add('header-shrink') : header.classList.remove('header-shrink');
        });
    };

    let initSearch = function () {
        let searchBtn = document.querySelector('.search-btn');
        let searchCloseBtn = document.querySelector('.search-close');
        let searchInput = document.querySelector('.search-input');
        let form = document.querySelector('.search-form');

        searchBtn.addEventListener('click', function (e) {
            toggleSearch(e);
            searchInput.focus();
        });

        searchCloseBtn.addEventListener('click', function (e) {
            toggleSearch(e);
            // searchInput.value = '';
        });

        document.querySelector('.body').onkeydown = function (e) {
            let code;

            if (e.key !== undefined) {
                code = e.key;
            } else if (e.keyIdentifier !== undefined) {
                code = e.keyIdentifier;
            } else if (e.keyCode !== undefined) {
                code = e.keyCode;
            }

            if (code === 'Enter' && searchInput === document.activeElement && searchInput.value) {
                form.submit();
            }
        };
    };

    let toggleSearch = function (e) {
        e.preventDefault();
        let searchForm = document.querySelector('.search-form');
        let navbar = document.querySelectorAll('.navbar-nav');
        let topnav = document.querySelector('.navbar');

        topnav.classList.toggle('topnav-open');

        for (let i=0; i<navbar.length; i++) {
            navbar[i].classList.toggle('d-none');
        }
        searchForm.classList.toggle('d-none');
    };

    let initMobileDropdown = function () {
        $('#top-navbar').on('show.bs.dropdown', function () {
            $('.navbar-icons').addClass('hide-link');
            $('.nav-item-simple').addClass('hide-link');
        });

        $('#top-navbar').on('hide.bs.dropdown', function () {
            $('.navbar-icons').removeClass('hide-link');
            $('.nav-item-simple').removeClass('hide-link');
        });
    };

    let initFilter = function (e) {

        let shops = document.querySelectorAll('.shop-column');
        let filters = document.querySelectorAll('.shop-filter a');

        filters.forEach(function (filter, key) {
            filter.addEventListener('click', function (e) {
                e.preventDefault();
                let categoryId = filter.dataset.categoryId;

                filters.forEach(function (otherFilter, otherKey) {
                    if (otherKey !== key) {
                        otherFilter.classList.remove('active');
                    }
                });

                filter.classList.add('active');

                shops.forEach(function (shop) {
                    if (categoryId  === shop.dataset.categoryId || !categoryId || shop.dataset.secondaryCategoryId.includes(categoryId)) {
                        shop.classList.remove('d-none');
                    } else {
                        shop.classList.add('d-none');
                    }
                });
            });
        });
    };

    return {
        /**
         * main function to initiate the module
         */
        init: function (e) {
            initLazyLoad();
            initBackToTop();
            initCarousel();
            initShrinkMenu();
            initSearch();
            initFancyBox();
            initMobileDropdown();
            initFilter(e);
        },
    };

}();

/**
 * Init site js
 */
$(document).ready(function () {
    Site.init();
});
